import React, { createContext, useContext, useRef, useState, useEffect, ReactNode } from "react";
import { getParamValue } from "../utils/UtilMethods";

// todo:
const BASE_URL = "http://localhost:54229";
const TARGET_HUB = "CheckStationHub";

export interface ICheckStationHubContext {
  connection: any;
  messages: string[];
  sendMessage: (message: string) => void;
  stopConnection: () => void;
}

export const CheckStationHubContext = createContext<ICheckStationHubContext | undefined>(undefined);

type Props = {
  children: ReactNode;
};

const CheckStationHubContextProvider: React.FC<Props> = ({ children }) => {
  const connectionRef = useRef<any>(null);
  const hubProxyRef = useRef<any>(null);
  const [messages, setMessages] = useState<string[]>([]);
  const [isScriptInjected, setIsScriptInjected] = useState(false);

  // const injectHubProxies = () => {
  //   const earlierScript = document.getElementById("hubs");
  //   if (earlierScript) earlierScript.remove();

  //   const script = document.createElement("script");
  //   script.src = `${BASE_URL}/signalr/hubs`;
  //   script.id = "hubs";
  //   script.async = true;

  //   script.onload = () => {
  //     setIsScriptInjected(true);
  //     console.log("Script loaded successfully.");
  //   };
  //   script.onerror = () => {
  //     console.error("Failed to load script. Retrying in 5 seconds...");
  //     setTimeout(injectHubProxies, 5000);
  //   };

  //   document.head.appendChild(script);
  // };

  // useEffect(() => {
  //   injectHubProxies();

  //   return () => {
  //     const script = document.getElementById("hubs");
  //     if (script) script.remove();
  //   };
  // }, []);

  useEffect(() => {
    return; // postponing feature, will remain commented.

    // if (!isScriptInjected) return;
    const connection = (window as any).jQuery.hubConnection(BASE_URL);
    connection.qs = { "Workstation-Id": getParamValue("ws") };

    // Create Hub Proxy
    const hubProxy = connection.createHubProxy(TARGET_HUB);

    hubProxy.on("ReceiveMessage", (message: string) => {
      console.log("Message from server:", message);
      setMessages((prev) => [...prev, message]); // Store received messages
    });

    connection.reconnecting(() => console.warn(`Reconnecting to ${TARGET_HUB}...`));
    connection.reconnected(() => console.log(`Reconnected to ${TARGET_HUB}!`));
    connection.disconnected(() => {
      console.error(`Disconnected from ${TARGET_HUB}.`);
      setTimeout(() => startConnection(connection), 5000); // Auto-reconnect
    });
    connection.error((error: any) => console.error("SignalR Error:", error));

    startConnection(connection);

    connectionRef.current = connection;
    hubProxyRef.current = hubProxy;

    return () => {
      connection.stop();
    };
  }, []); //isScriptInjected

  const sendMessage = (message: string) => {
    if (hubProxyRef.current) {
      hubProxyRef.current
        .invoke("SendMessageToExternalHub", message)
        .done(() => console.log("Sent to external hub"))
        .fail((err: any) => console.error("Error sending message:", err.toString()));
    }
  };

  const stopConnection = () => {
    if (connectionRef.current) {
      connectionRef.current.stop();
      console.log("Connection stopped.");
    }
  };

  return (
    <CheckStationHubContext.Provider
      value={{ connection: connectionRef.current, messages, sendMessage, stopConnection }}
    >
      {children}
    </CheckStationHubContext.Provider>
  );
};

export function useCheckStationHubContext() {
  const context = useContext(CheckStationHubContext);
  if (!context) {
    throw new Error("useCheckStationHubContext must be used within CheckStationHubProvider");
  }
  return context;
}

export default CheckStationHubContextProvider;

const startConnection = (connection: any) => {
  connection
    .start()
    .done(() => console.log("Connected successfully."))
    .fail((err: any) => console.error("Connection failed:", err.toString()));
};
